module.exports = __webpack_public_path__ + "img/farming_nr3_2.f97576ab.png";